import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { AuthShell } from "@/components/AuthShell";
import { PasswordInput } from "@/components/PasswordInput";
import { formatApiError } from "@/context/AuthContext";
import { API } from "@/lib/api";
import { T } from "@/lib/i18n";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [pw, setPw] = useState({ a: "", b: "" });
  const [state, setState] = useState({ loading: false, error: "" });

  const onSubmit = async (e) => {
    e.preventDefault();
    if (pw.a.length < 6) return setState({ loading: false, error: T("La password deve avere almeno 6 caratteri", "Password must be at least 6 characters") });
    if (pw.a !== pw.b) return setState({ loading: false, error: T("Le due password non coincidono", "The two passwords don't match") });
    setState({ loading: true, error: "" });
    try {
      await axios.post(`${API}/auth/reset-password`, { token, password: pw.a });
      toast.success(T("Password aggiornata: ora puoi accedere", "Password updated: you can log in now"));
      setTimeout(() => window.location.assign("/login"), 900);
    } catch (err) {
      const expired = err.response?.status === 400 && pw.a.length >= 6;
      setState({ loading: false, error: expired ? T("Link non valido o scaduto.", "Invalid or expired link.") : formatApiError(err) });
    }
  };

  if (!token) return (
    <AuthShell title={T("Link non valido", "Invalid link")} subtitle={T("Il link è incompleto o scaduto.", "The link is incomplete or expired.")}>
      <Link data-testid="reset-request-new" to="/forgot-password" className="aurora-text font-medium">{T("Richiedi un nuovo link", "Request a new link")}</Link>
    </AuthShell>
  );

  return (
    <AuthShell title={T("Nuova password", "New password")} subtitle={T("Scegli la nuova password per il tuo account.", "Choose the new password for your account.")}>
      <form onSubmit={onSubmit} className="space-y-4">
        <PasswordInput testid="reset-password-input" autoComplete="new-password" placeholder={T("min 6 caratteri")} value={pw.a} onChange={(e) => setPw({ ...pw, a: e.target.value })} />
        <PasswordInput testid="reset-password-confirm" autoComplete="new-password" placeholder={T("Ripeti la password", "Repeat the password")} value={pw.b} onChange={(e) => setPw({ ...pw, b: e.target.value })} />
        {state.error && (
          <p data-testid="reset-error" className="text-sm text-[#f87171]">{state.error}{" "}
            <Link to="/forgot-password" className="underline">{T("Richiedi un nuovo link", "Request a new link")}</Link>
          </p>
        )}
        <Button type="submit" data-testid="reset-submit-btn" disabled={state.loading} className="w-full h-12 aurora-gradient hover:opacity-90 text-white rounded-sm font-medium">
          {state.loading ? <Loader2 className="w-4 h-4 animate-spin" /> : T("Salva la nuova password", "Save new password")}
        </Button>
      </form>
    </AuthShell>
  );
}
